  <template>
  <div id="echart_trend">
    <form>
      <v-layout row wrap>
        <v-flex xs12 class="pt-1 pl-3">
          <h3>{{lastTemperatureLabel}}</h3>
          <div>{{lastTemperatureDataFixed+' '+temperatureUnit}} </div>
        </v-flex>
      </v-layout>
      <hr class="ma-3">
      <v-layout row justify-space-between class="pl-5 pr-5">
        <v-flex xs4>
          <v-tooltip bottom :disabled="!showPeriodMessagePeriodJump" v-model="showPeriodMessagePeriodJump"
            content-class="tooltipMessagePeriodJump">
            <v-select
              :label="$t('chart.change-period')"
              :items="items"
              v-model="period"
              id="period"
              hide-details
              :disabled="!earliestLogInfo.existsLogAllServices"
              slot="activator"
            ></v-select>
            <span>{{messagePeriodJump}}</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs2>
          <v-btn
            small outline
            type="button"
            v-on:click="jumpToRecent"
            :disabled="reloading||autoReload"
          >
            {{$t("chart.button-reload")}}
          </v-btn>
        </v-flex>
      </v-layout>
    </form>
    <v-layout row wrap>
      <v-flex xs12>
        <div :id="myChartId" style="width:100%; height:400px;"></div>
      </v-flex>

    </v-layout>
    <graph-date-select ref="graphDateSelect"
      :locale="locale"
      :timezone="timezone"
      :earliestLogInfo="earliestLogInfo"
      :messagePeriodJump="messagePeriodJump"
      :messageNoData="messageNoData"
      :showJumpMessagePeriodJumpProp="showJumpMessagePeriodJump"
      v-on:changeDatetime="changeDatetime"
      v-on:jumpToDatetime="jumpToDatetime"
      v-on:jumpToRecent="jumpToRecent" />
  </div>
</template>

<script>
import echarts from 'echarts'
// import moment from 'moment'
import Graph from '@/utils/graph.js'
import graphHelper from '@/utils/graphhelper.js'
import utils from '@/utils/utils.js'
import GraphDateSelect from '@/components/GraphDateSelect'

export default {
  components: {
    GraphDateSelect
  },
  name: 'TemperatureLogChart',
  props: {
    // 親のテンプレートで指定した場合はそれを使う
    // 未指定の場合はUUIDユニークな値を自ら生成する
    id: {
      type: String,
      default () {
        return 'chart_' + utils.generateUuid()
      }
    },
    // グラフに描画する対象のデータID（必須）
    dataId: {
      type: String,
      required: true
    },
    // グラフ描画時のタイムゾーン設定
    timezone: {
      type: String,
      default: 'UTC'
    },
    activeTab: {
      type: String,
      default: ''
    },
    properties: {
      type: String,
      default: 'TemperatureLog'
    },
    color: {
      type: String,
      default: 'blue'
    },
    earliestLogInfo: Object
  },

  data () {
    return {
      // グラフデータの１プロットの間隔
      period: '15m',
      //
      items: [
        {value: '15m', text: this.$t('chart.15m')},
        {value: '1h', text: this.$t('chart.1h')},
        {value: '1d', text: this.$t('chart.1d')},
        {value: '1w', text: this.$t('chart.1w')},
        {value: '1M', text: this.$t('chart.1M')}
      ],
      // 親側で切り替えられると困るので、ここで保持しておく
      myChartId: this.id,
      // ECharts のインスタンス
      myChart: null,
      // dataZoom で現在表示中のレンジ
      range: {
        start: null,
        end: null
      },
      // dataZoom で前回表示していたレンジ
      prevRange: {
        start: null,
        end: null
      },
      firstZoomRange: null, // 初回ズーム時のレンジ
      // 日付選択
      toDatetimeUnixTime: 0,
      messagePeriodJump: '',
      messageNoData: '',
      isChangedPeriod: false, // 時間間隔を変更した場合
      isChangedRangeBar: false, // レンジバーを変更した場合
      isChangeRangeBarWidth: false, // レンジバーの幅を変更している場合
      isDataZoom: false, // ズーム範囲選択した場合
      showPeriodMessagePeriodJump: false, // 時間間隔変更時メッセージ表示
      showJumpMessagePeriodJump: false, // 日時指定移動時メッセージ表示

      // グラフの表示データ
      xAxisDatas: [],
      seriesDatas: [],
      outOfFromTimestamp: null, // fromより古いデータのうち一番新しいデータ
      outOfFromSeriesData: [],
      outOfToTimestamp: null, // toより新しいデータのうち一番古いデータ
      outOfToSeriesData: [],

      // リロード中フラグ
      reloading: false,
      autoReload: false,
      setIntervalId: null,

      // ブラウザのロケール情報
      locale: this.$store.getters.locale,
      dateOptions: [],

      // 現在の温度表示ラベル
      lastTemperatureLabel: this.$t('watersystem.now-temperature'),

      // 温度 RATE用の瞬時値
      lastTemperatureDataFixed: utils.convertTemperatureUnit(0, this.$store.getters.settingParams.temperatureUnit),
      // 温度の表示単位
      temperatureUnit: this.$store.getters.settingParams.temperatureUnit,
      // サービスのコードリスト
      serviceCodes: this.$store.getters.serviceList.codes
    }
  },

  computed: {
    // API呼び出し時に渡す
    params () {
      return {
        dataId: this.dataId,
        period: this.period,
        sort: 'asc', // 固定
        timezone: this.timezone,
        from: this.from,
        to: this.to,
        firstDayOfWeek: utils.firstDayOfWeek(this.locale)
      }
    },

    // 現在のグラフの描画範囲（レンジの差分, 秒）
    rangeDiff () {
      return this.range.end - this.range.start
    },
    // APIのfromに指定する値
    from () {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      let offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2
      }

      return this.range.end - offsetFromPeriods * this.periodTime
    },
    // APIのtoに指定する値
    to () {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      let offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2
      }

      return this.range.end + offsetFromPeriods * this.periodTime
    },
    periodTime () {
      return {
        '15m': 60 * 15,
        '1h': 60 * 60,
        '1d': 60 * 60 * 24,
        '1w': 60 * 60 * 24 * 7,
        '1M': 60 * 60 * 24 * 30
      }[this.period]
    }
  },

  methods: {
    // データ取得＆グラフ描画処理
    reload () {
      var self = this

      // ローディング状態にする（ボタン無効化）
      self.reloading = true
      // グラフのローディングを表示
      self.myChart.showLoading()
      var params = self.params

      // API呼び出し
      self.graph.temperatureLog(params)
        .then((data) => {
          // Echartsオプション初期化
          self.initializeChartOption()
          self.messageNoData = ''
          var option = data
          // 初期化
          self.xAxisDatas = []
          self.seriesDatas = []
          self.outOfFromTimestamp = null
          self.outOfFromSeriesData = []
          self.outOfToTimestamp = null
          self.outOfToSeriesData = []

          // レスポンスのデータをグラフにセット
          option.dataZoom = [
            {
              // API呼び出し前にセットしていたレンジを再設定
              startValue: self.range.start.toString(),
              endValue: self.range.end.toString()
            }
          ]
          if (!option.xAxis.data.length) {
            // データがない場合は移動ボタンを無効化しメッセージ表示
            self.$refs.graphDateSelect.setDisableJump(true)
            self.messageNoData = self.$t('chart.message-no-data')
            return
          }

          option.series.forEach((one) => {
            one.data.forEach((element, index) => {
              if (element !== null) {
                one.data[index] = self.convertTemperatureUnit(element, self.pressureUnit)
              }
            })
          })
          // APIの引数from,toの範囲外のデータの切り詰め
          option = graphHelper.omitOutOfRangeFromToData(self, option)

          // option.dataZoom[0]の切り詰め
          option = graphHelper.fixOptionDataZoomRange(self, option)

          // 日付選択範囲によるメッセージ
          graphHelper.setMessagePeriodJump(self, {
            'start': Number(option.dataZoom[0].startValue),
            'end': Number(option.dataZoom[0].endValue)
          })
          // データが少ない場合は移動ボタンを無効化
          self.setDisableJump({
            start: Number(option.dataZoom[0].startValue),
            end: Number(option.dataZoom[0].endValue)
          })

          // 先頭と末尾のデータ補正
          option = this.fillPlotStartEnd(option)
          // グラフデータを再設定
          self.myChart.setOption(option)

          // dataZoom.rangeMode をパーセンテージに変更する
          // startValue, endValue の設定「後」にこれを行わないと、
          // dataZoom の labelFormatter がうまく効いてくれない
          setTimeout(() => {
            self.myChart.setOption({ dataZoom: [ { rangeMode: ['percent', 'percent'] } ] })
          }, 0)
        })
        .catch((error) => {
          console.log(error)
          // alert(JSON.stringify(error, null, 2))
        })
        .then(() => { // finally
          // ローディング状態を解除（ボタン有効化）
          self.reloading = false
          // グラフのローディングを非表示
          self.myChart.hideLoading()
          // 読み込み時にwidth100%にする
          self.myChart.resize()
        })
      // メタデータの更新のためにgetFiltrationSystemを発火
      this.$emit('child-action')
    },
    // 先頭と末尾のデータ補正
    fillPlotStartEnd (option) {
      const RATE_SERIES_INDEX = 0 // Rateのindex
      // 描画範囲内、描画範囲外のプロット位置の取得
      let fillPlotsRangeDatasets = graphHelper.retrieveFillPlotsRangeDatasets(this, option, RATE_SERIES_INDEX)

      option.xAxis.data = fillPlotsRangeDatasets.option.xAxis.data
      option.series = fillPlotsRangeDatasets.option.series
      let viewRangeStartIndex = fillPlotsRangeDatasets.viewRangeStartIndex
      let viewRangeEndIndex = fillPlotsRangeDatasets.viewRangeEndIndex

      let rangeDatasets = fillPlotsRangeDatasets.rangeDatasets
      // データがない状態から、データが取得できた場合は最古のタイムスタンプを反映
      this.emitEarliestTimestamp(rangeDatasets)

      // 描画範囲の先頭にプロットが描画されていない場合 かつ 描画範囲の前のデータがある場合
      if (option.series[RATE_SERIES_INDEX].data[viewRangeStartIndex] === null &&
        rangeDatasets.outOfViewRangeStart.timestamp !== null
      ) {
        // 描画範囲の前のデータの次のデータ:タイムスタンプ
        let nextDataTimestamp = rangeDatasets.oldestViewRange.timestamp
        // 描画範囲の前のデータの次のデータ:値
        let nextDataSeriesData = JSON.parse(JSON.stringify(rangeDatasets.oldestViewRange.seriesData))
        // 描画範囲内の最古のデータがない場合かつ描画範囲のendより後のデータがある場合は描画範囲のendより後のデータのタイムスタンプを利用
        if (nextDataTimestamp === null && rangeDatasets.latestViewRange.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.latestViewRange.timestamp
          nextDataSeriesData = JSON.parse(JSON.stringify(rangeDatasets.latestViewRange.seriesData))
        }
        if (nextDataTimestamp === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.outOfViewRangeEnd.timestamp
          nextDataSeriesData = JSON.parse(JSON.stringify(rangeDatasets.outOfViewRangeEnd.seriesData))
        }
        // 描画範囲内の最古のデータがない場合、かつは描画範囲のendより後のデータがない場合、描画範囲の先頭のタイムスタンプを利用
        if (nextDataTimestamp === null) {
          nextDataTimestamp = option.xAxis.data[viewRangeStartIndex]
        }
        // 描画範囲のstartの前の時刻から描画範囲の最古のデータの時刻までの経過時間
        const pasttimeFromOutOfStartToOldestRange = nextDataTimestamp - rangeDatasets.outOfViewRangeStart.timestamp
        // 描画範囲のstartの前の時刻から描画範囲の先頭の時刻までの経過時間
        const pasttimeFromOutOfStartToRangeStart = option.xAxis.data[viewRangeStartIndex] - rangeDatasets.outOfViewRangeStart.timestamp
        // 経過率
        let pasttimeRatio = pasttimeFromOutOfStartToOldestRange === 0 ? 1 : Number(pasttimeFromOutOfStartToRangeStart / pasttimeFromOutOfStartToOldestRange)

        // 描画範囲の前の値 - (描画範囲の前の値 - 描画範囲の先頭の値) * 経過率
        nextDataSeriesData[RATE_SERIES_INDEX] = rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX] -
          (rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX] - nextDataSeriesData[RATE_SERIES_INDEX]) * Number(pasttimeRatio)
        // 先頭にfromより前のデータを設定
        option.series[RATE_SERIES_INDEX].data[viewRangeStartIndex] = {
          value: nextDataSeriesData[RATE_SERIES_INDEX],
          symbolSize: 0
        }
      }
      // 描画範囲の末尾にプロットが描画されていない場合 かつ 描画範囲の後のデータがある場合
      if (option.series[RATE_SERIES_INDEX].data[viewRangeEndIndex] === null &&
        rangeDatasets.outOfViewRangeEnd.timestamp !== null
      ) {
        // 描画範囲の後のデータの前のデータ:タイムスタンプ
        let prevDataTimestamp = rangeDatasets.latestViewRange.timestamp
        // 描画範囲の前のデータの次のデータ:値
        let prevDataSeriesData = JSON.parse(JSON.stringify(rangeDatasets.latestViewRange.seriesData))
        // 描画範囲内の最新のデータがない場合かつ描画範囲のstartより前のデータがある場合は描画範囲のstartより前のデータのタイムスタンプを利用
        if (prevDataTimestamp === null && rangeDatasets.oldestViewRange.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.oldestViewRange.timestamp
          prevDataSeriesData = JSON.parse(JSON.stringify(rangeDatasets.oldestViewRange.seriesData))
        }
        if (prevDataTimestamp === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.outOfViewRangeStart.timestamp
          prevDataSeriesData = JSON.parse(JSON.stringify(rangeDatasets.outOfViewRangeStart.seriesData))
        }
        // 描画範囲内の最新のデータがない場合、かつは描画範囲のstartより前のデータがない場合、描画範囲の末尾のタイムスタンプを利用
        if (prevDataTimestamp === null) {
          prevDataTimestamp = option.xAxis.data[viewRangeEndIndex]
        }
        // 描画範囲内の最新の時刻から描画範囲のendの後のデータの時刻までの経過時間
        const pasttimeFromLatestRangeToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - prevDataTimestamp
        // 描画範囲の末尾の時刻から描画範囲のendの後のデータの時刻までの経過時間
        const pasttimeFromRangeEndToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - option.xAxis.data[viewRangeEndIndex]
        // 経過率
        let pasttimeRatio = pasttimeFromLatestRangeToOutOfEnd === 0 ? 1 : Number(pasttimeFromRangeEndToOutOfEnd / pasttimeFromLatestRangeToOutOfEnd)
        // 描画範囲の末尾のデータの値
        // 描画範囲の後の値 - (描画範囲の後の値 - 描画範囲の末尾の値) * 経過率
        prevDataSeriesData[RATE_SERIES_INDEX] = rangeDatasets.outOfViewRangeEnd.seriesData[RATE_SERIES_INDEX] -
          (rangeDatasets.outOfViewRangeEnd.seriesData[RATE_SERIES_INDEX] - prevDataSeriesData[RATE_SERIES_INDEX]) * Number(pasttimeRatio)
        // 末尾にfromより後のデータを設定
        option.series[RATE_SERIES_INDEX].data[viewRangeEndIndex] = {
          value: prevDataSeriesData[RATE_SERIES_INDEX],
          symbolSize: 0
        }
      }
      this.fillLastData(rangeDatasets)
      return option
    },
    emitEarliestTimestamp (rangeDatasets) {
      if (rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.outOfViewRangeStart.timestamp)
      } else if (rangeDatasets.oldestViewRange.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.oldestViewRange.timestamp)
      }
    },
    // 描画範囲の最後の値の設定
    fillLastData (rangeDatasets) {
      const RATE_SERIES_INDEX = 0 // Rateのindex
      let lastTemperatureData = null
      let lastTimestamp = rangeDatasets.latestViewRange.timestamp
      let isExistsOutOfViewRange = false
      // 描画範囲のendの後の値がある
      if (this.xAxisDatas.indexOf(rangeDatasets.outOfViewRangeEnd.timestamp) !== -1 &&
        this.seriesDatas[RATE_SERIES_INDEX].data[this.xAxisDatas.indexOf(rangeDatasets.outOfViewRangeEnd.timestamp)] !== null) {
        isExistsOutOfViewRange = true
      }
      // 描画範囲の最新の値がある
      if (lastTimestamp !== null) {
        lastTemperatureData = rangeDatasets.latestViewRange.seriesData[RATE_SERIES_INDEX]
      }
      if (lastTemperatureData === null) {
        lastTimestamp = rangeDatasets.oldestViewRange.timestamp
        // 描画範囲の最古の値がある
        if (lastTimestamp !== null) {
          lastTemperatureData = rangeDatasets.oldestViewRange.seriesData[RATE_SERIES_INDEX]
        }
      }
      if (lastTemperatureData === null) {
        lastTimestamp = rangeDatasets.outOfViewRangeStart.timestamp
        // 描画範囲のstartの前の値がある
        if (lastTimestamp !== null) {
          lastTemperatureData = rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX]
        }
      }
      if (lastTemperatureData === null) {
        // データが設定されていない
        this.lastTemperatureDataFixed = utils.convertTemperatureUnit(0, this.temperatureUnit)
        this.lastTemperatureLabel = this.$t('watersystem.now-temperature')
      } else {
        // データが設定されている
        this.lastTemperatureDataFixed = Number(lastTemperatureData).toFixed(1)
        if (rangeDatasets.outOfViewRangeEnd.timestamp !== null && isExistsOutOfViewRange) {
          // 描画範囲のendの後の値がある
          this.lastTemperatureLabel = this.$t('watersystem.past-temperature', [this.formatLastUpdateDate(lastTimestamp * 1000)])
        } else {
          // 描画範囲のendの後の値がない
          this.lastTemperatureLabel = this.$t('watersystem.now-temperature') +
            ' (' + this.$t('watersystem.last-update-for-chart') + ':' + this.formatLastUpdateDate(lastTimestamp * 1000) + ')'
        }
      }
    },
    formatLastUpdateDate (unixTimestamp) {
      let options = {}
      switch (this.period) {
        case '15m':
          options = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
          break
        case '1h':
          options = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric'}
          break
        case '1d':
          options = {year: 'numeric', month: 'numeric', day: 'numeric'}
          break
        case '1w':
          options = {year: 'numeric', month: 'numeric', day: 'numeric'}
          break
        case '1M':
          options = {year: 'numeric', month: 'long'}
          break
      }
      options.timeZone = this.timezone
      this.locale = this.$store.getters.locale

      return this.period === '1w'
        ? this.$t('watersystem.last-update-week-suffix-for-chart',
          [utils.dateFormatter(this.locale, unixTimestamp, options)])
        : utils.dateFormatter(this.locale, unixTimestamp, options)
    },
    // ウィンドウのリサイズイベントを取得する
    onResize (event) {
      if (this.myChart) {
        // width or height を auto や % 指定している場合は必須
        this.myChart.resize()
      }
    },
    // 単位を変換
    convertTemperatureUnit (temperature) {
      return utils.convertTemperatureUnit(temperature, this.temperatureUnit)
    },
    changeDatetime (toDatetimeUnixTime) {
      this.toDatetimeUnixTime = toDatetimeUnixTime
    },
    // 指定した時刻にジャンプする
    jumpToDatetime (toDatetimeUnixTime) {
      // グラフ描画のレンジを設定しておく
      this.range = graphHelper.getRangeByToDatetimePeriod(this, toDatetimeUnixTime)
      graphHelper.resetDataZoomToolBox(this)
      this.reload()
    },
    // 最新時刻にジャンプする
    jumpToRecent (toDatetimeUnixTime) {
      graphHelper.jumpToRecent(this, toDatetimeUnixTime)
    },
    // プロット範囲が13プロット(時刻範囲が12 * 時間間隔)より小さい場合は移動ボタンを無効化
    setDisableJump (range) {
      const isGetAllData = this.outOfFromTimestamp === null && this.outOfToTimestamp === null
      const viewRangeStartIndex = this.xAxisDatas.indexOf(this.range.start)
      const viewRangeEndIndex = this.xAxisDatas.indexOf(this.range.end)

      if (isGetAllData && viewRangeStartIndex === 0 && viewRangeEndIndex === this.xAxisDatas.length - 1) {
        this.$refs.graphDateSelect.setDisableJump(true)
      } else {
        this.$refs.graphDateSelect.setDisableJump(false)
      }
    },
    // Echartsオプション初期化
    initializeChartOption () {
      let self = this

      // Echarts初期設定
      const option = {
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter (params/* , ticket, callback */) {
            // callback形式を使うのは、params[0].valueが電圧から変換される関係上、小さい値まで表示されるから。
            // Rateの値がない(サーバ上のデータがない)場合、かつ現在時刻から計算した最新時刻でない場合はツールチップは表示しない
            const rangeLast = self.xAxisDatas[self.xAxisDatas.length - 1]
            const originalValue = self.seriesDatas[0].data[params[0].dataIndex]
            if (originalValue === null && Number(params[0].axisValue) !== rangeLast) {
              return ''
            }
            return /* params[0].seriresName + ':' */ 'Temperature:' + Number(params[0].value).toFixed(2)
          }
        },
        // HARPS-242 縦軸ズームをしたい
        // * -> 中止(UI上抑止し、Echarts4以降でライブラリが改善されていれば、対応)
        toolbox: {
          // show: true, // UI抑止解除の際はフラグをtrueにする
          show: false,
          top: '16%',
          right: '11%',
          borderRadius: 1,
          borderWidth: 1,
          feature: {
            dataZoom: {
              // show: true, // UI抑止解除の際はフラグをtrueにする
              show: false,
              title: {
                zoom: self.$t('chart.dataZoom-zoom'),
                back: self.$t('chart.dataZoom-back')
              },
              iconStyle: {
                emphasis: {
                  textPosition: 'bottom',
                  textAlign: 'right',
                  borderColor: '#009933'
                }
              }
            }
          }
        },
        legend: {
          data: ['TemperatureLog']
        },
        xAxis: {
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          data: [],
          axisLabel: {
            formatter (value, index) {
              // タイムスタンプは UNIX-Time (秒) の値をそのまま持たせて、
              // 描画時に文字列に変換する
              self.dateOptions = utils.getDateOptions(self.period)
              self.dateOptions.timeZone = self.timezone
              return utils.dateFormatter(self.locale, value * 1000, self.dateOptions)
            }
          }
        },
        yAxis: {
          name: '(' + this.temperatureUnit + ')'
        },
        series: [],
        dataZoom: [
          {
            type: 'slider',
            realtime: false,
            labelFormatter (value, valueStr) {
              let options = utils.getDateOptions(self.period, true)
              options.timezone = self.timezone
              if (valueStr !== '') {
                return utils.dateFormatter(self.locale, Number(valueStr) * 1000, options)
              }
            }
          }
        ]
      }

      self.properties.split(',').forEach((property) => {
        switch (property) {
          default:
            option.series.push({
              name: property,
              type: 'line',
              itemStyle: {
                normal: {color: '#008800'}
              },
              data: [],
              connectNulls: true,
              symbolSize: 6,
              showAllSymbol: true
            })
        }
      })

      self.myChart.setOption(option)
    }
  },

  watch: {
    dataId () {
      // 初回データロード時は最新表示
      this.$refs.graphDateSelect.jumpToRecent()
    },
    properties () {
      this.reload()
    },
    // グラフ描画レンジの時間単位を変更する
    period () {
      // グラフ描画のレンジを設定しておく
      this.isChangeRangeBarWidth = false
      this.range = graphHelper.getRangeByToDatetimePeriod(this, this.toDatetimeUnixTime)
      this.$refs.graphDateSelect.resetWaitingJump()
      this.isChangedPeriod = true
      graphHelper.resetDataZoomToolBox(this)
      this.reload()
    },
    timezone () {
      this.reload()
    },
    activeTab () {
      this.reload()
      if (this.activeTab === this.serviceCodes[5]) {
        if (this.myChart) {
          // width or height を auto や % 指定している場合は必須
          this.myChart.resize()
        }
      }
    },
    autoReload () {
      // 自動リロードの有効化
      if (this.autoReload === true) {
        this.setIntervalId = setInterval(() => {
          this.jumpToRecent()
        }, 2000)
      } else {
        clearInterval(this.setIntervalId)
      }
    }
  },

  created () {
    // 直近からグラフ描画のレンジを設定しておく
    var now = Math.floor(Date.now() / 1000)
    now = now - (now % this.periodTime)
    this.range.start = now - (this.periodTime * 12)
    this.range.end = now

    this.prevRange = this.range

    this.graph = new Graph({
      token: 'MyToken'
    })
  },

  mounted () {
    var self = this

    // ウィンドウのリサイズイベントのハンドラ登録
    window.addEventListener('resize', self.onResize)

    // Echartsインスタンス生成
    self.myChart = echarts.init(document.getElementById(self.myChartId))
    // Echartsオプション初期化
    self.initializeChartOption()

    // datazoom イベントのハンドラを設定
    self.myChart.on('datazoom', (event) => {
      var axis = self.myChart.getModel().option.xAxis[0]
      // 現在描画されているレンジのインデックスを取得
      var start = (axis.rangeStart === null || axis.rangeStart < 0) ? 0 : axis.rangeStart
      var end = (axis.rangeEnd === null || axis.rangeEnd >= axis.data.length) ? axis.data.length - 1 : axis.rangeEnd
      // 現在描画されているレンジの値を保存
      self.prevRange = self.range
      // 現在描画されているレンジの値を設定
      self.range = {
        start: axis.data[start],
        end: axis.data[end]
      }
      if (self.myChart.getModel().option.toolbox[0].feature.dataZoom.show) {
        self.isDataZoom = event.batch !== undefined
        // 履歴の先頭に戻った場合はレンジをズームした時点に戻す
        if (event.batch !== undefined) {
          const ecToolBox = self.myChart.getModel()._componentsMap._ec_toolbox
          let ecToolBoxModel = ecToolBox[0].ecModel
          if (ecToolBoxModel['\0_ec_hist_store'].length === 2 && self.firstZoomRange === null) {
            self.firstZoomRange = JSON.parse(JSON.stringify(self.prevRange))
          } else if (ecToolBoxModel['\0_ec_hist_store'].length === 1 && self.firstZoomRange !== null) {
            self.range = JSON.parse(JSON.stringify(self.firstZoomRange))
            self.firstZoomRange = null
          }
        }
      }

      self.isChangedRangeBar = true
      // レンジバーの幅の変更があったかどうか
      self.isChangeRangeBarWidth = self.isChangeRangeBarWidth ||
        (self.range.end - self.range.start) !== ((self.prevRange.end - self.prevRange.start))
      if ((start === 0) && (self.range.start !== self.prevRange.start)) {
        // 先頭に達した場合はグラフのデータをロードする
        self.reload()
      } else if ((start === 0) && (self.range.start === self.prevRange.start) && self.outOfFromTimestamp !== null) {
        // 先頭に達した場合はグラフのデータをロードする
        const rangeOffset = Math.floor(self.rangeDiff / 2)
        self.range = {
          start: self.range.start - rangeOffset,
          end: self.range.end - rangeOffset
        }
        self.reload()
      } else if ((end === (axis.data.length - 1)) && (self.range.end !== self.prevRange.end)) {
        // 末尾に達した場合はグラフ外のデータをロードする
        self.reload()
      } else {
        // 先頭と末尾を再描画
        let option = {
          xAxis: [],
          series: [],
          dataZoom: [
            {
              // API呼び出し前にセットしていたレンジを再設定
              startValue: self.range.start.toString(),
              endValue: self.range.end.toString()
            }
          ]
        }
        option = self.fillPlotStartEnd(option)
        setTimeout(() => {
          self.myChart.setOption(option)
        }, 0)
        self.setDisableJump(self.range)
      }
    })

    // クリックイベントハンドラを設定
    // クリックした場合は日付選択フォームを更新する
    self.myChart.on('click', (event) => {
      // event.nameは選択した日時のUNIXタイムスタンプを示す
      self.toDatetimeUnixTime = Number(event.name)
      self.$refs.graphDateSelect.changeSelectDateTime(self.toDatetimeUnixTime)
    })

    // 初回データロード時は最新表示
    this.$refs.graphDateSelect.jumpToRecent()
  },
  beforeDestroy () {
    // ウィンドウのリサイズイベントのハンドラ登録を解除
    window.removeEventListener('resize', this.onResize)
    // EChartsインスタンス破棄
    this.myChart = null
  }
}
</script>
<style>
.datepicker-dialog.dialog--active.dialog--persistent {width: 307px !important;}
.datepicker-dialog.dialog--active.dialog--persistent .picker {width: 307px !important;}
</style>



// WEBPACK FOOTER //
// TemperatureLogChart.vue?6029cc53